import { CircleCheck, CircleDashed, Clock, type LucideIcon, Send, TriangleAlert } from 'lucide-react';

import { STATUS_LABEL } from '@escala/domain/schedule';
import type { ScheduleStatus } from '@escala/domain/types';

/**
 * Aparência de cada status da escala. As classes são literais (não montadas) para o
 * scanner do Tailwind gerá-las.
 */
export const STATUS_META: Record<
  ScheduleStatus,
  { label: string; icon: LucideIcon; text: string; bg: string; line: string; bar: string; border: string }
> = {
  published: {
    label: STATUS_LABEL.published,
    icon: Send,
    text: 'text-status-published',
    bg: 'bg-status-published-bg',
    line: 'border-status-published-line',
    bar: 'bg-status-published-bar',
    border: 'border-l-status-published-bar',
  },
  complete: {
    label: STATUS_LABEL.complete,
    icon: CircleCheck,
    text: 'text-status-complete',
    bg: 'bg-status-complete-bg',
    line: 'border-status-complete-line',
    bar: 'bg-status-complete-bar',
    border: 'border-l-status-complete-bar',
  },
  partial: {
    label: STATUS_LABEL.partial,
    icon: CircleDashed,
    text: 'text-status-partial',
    bg: 'bg-status-partial-bg',
    line: 'border-status-partial-line',
    bar: 'bg-status-partial-bar',
    border: 'border-l-status-partial-bar',
  },
  conflict: {
    label: STATUS_LABEL.conflict,
    icon: TriangleAlert,
    text: 'text-status-conflict',
    bg: 'bg-status-conflict-bg',
    line: 'border-status-conflict-line',
    bar: 'bg-status-conflict-bar',
    border: 'border-l-status-conflict-bar',
  },
  awaiting: {
    label: STATUS_LABEL.awaiting,
    icon: Clock,
    text: 'text-status-awaiting',
    bg: 'bg-status-awaiting-bg',
    line: 'border-status-awaiting-line',
    bar: 'bg-status-awaiting-bar',
    border: 'border-l-status-awaiting-bar',
  },
};

/** Cor do bloco de data de um evento: conflito e parcial chamam atenção; o resto fica índigo. */
export function dateTone(status: ScheduleStatus): 'primary' | 'partial' | 'conflict' {
  return status === 'conflict' || status === 'partial' ? status : 'primary';
}
